import React from 'react';
import { Flex, Box, Heading, Text } from 'rebass';
import { Link as GatsbyLink} from 'gatsby';
import styled from '@emotion/styled';
import { colors } from '../../gatsby-plugin-theme-ui/index.js'

import IndividualProduct from './IndividualProduct';
import MainPagination from '../../components/VendorPagination';
import CollectionStats from '../../components/CollectionStats';

const StyledLink = styled(GatsbyLink)(({ theme }) => ({
  color: 'white',
  display: 'inline-block',
  backgroundColor: '#333',
  padding: '5px 10px',
  marginRight: '10px',
  marginBottom: '10px',
  borderRadius: 9999,
  textTransform: 'capitalize',
  '&.active': {
    backgroundColor: `${theme.colors.primary}`
  },
  ':hover,:focus,.active': {
    backgroundColor: `${theme.colors.primary}`,
    textDecoration: 'none',
    color: 'white'
  },
}));

function MainCatalogPage(props) {
  const {
    gatsbyImageProps,
  } = props.data.store.siteMetadata.gatsbyStorefrontConfig;
  const { limit, skip, cartUrl, vendor, categories, vendorCategories, menu } = props.pageContext;
  let products = [];

  products = props.data.vendor.nodes.length > 0 ? props.data.vendor.nodes : [];

  return (
    <Flex flexWrap="wrap" px={2} pt={3} mx="auto" style={{ maxWidth: 1300 }}>

      <Flex
        width={1}
        px={4}
        py={2}
        mt={[4,2,2,2]}
        flexWrap={['wrap', 'nowrap']}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Text textAlign="left">
          <Heading as="h1" fontSize={[30, 36, 42]}>
            {vendor.name === 'Epink' ? 'Caroline Causse Clothing' : vendor.name}
          </Heading>
        </Text>
      </Flex>

      {vendor.description ? (
        <Box
          width={1} px={4} py={2} mx={0}
          dangerouslySetInnerHTML={{ __html: vendor.description.childMarkdownRemark.html }}
          sx={{
            overflow: ['scroll', 'hidden'],
            mx: 3,
            fontSize:[2, 3]
          }}
        ></Box>
        ) : ('')
      }

      <Flex
        width={1}
        px={4}
        py={2}
        flexWrap={['wrap', 'nowrap']}
        alignItems="center"
        >
       <Box
          width={'100%'}
          onSubmit={e => e.preventDefault()}
          py={3}>
          <StyledLink
            key={`/${vendor.slug === 'epink' ? 'caroline-causse-clothing' : vendor.slug}`}
            to={`/${vendor.slug === 'epink' ? 'caroline-causse-clothing' : vendor.slug}`}
            activeClassName='active'
          >
            Tout
          </StyledLink>
          {vendorCategories.map((cat, index) => {
            let link = null;
            if (cat.tags.includes('femmes')) {
              link = `/${vendor.slug === 'epink' ? 'caroline-causse-clothing' : vendor.slug}-${cat.handle}`;
            } else {
              link = `/${vendor.slug === 'epink' ? 'caroline-causse-clothing' : vendor.slug}-${cat.handle}`;
            }
            return (
              <StyledLink
                key={`${link}`}
                to={`${link}`}
                activeClassName='active'
              >
                {cat.name}
              </StyledLink>
            )
          })}
        </Box>
        <Box
          display={'none', 'inline-block'}
          width="250px"
          textAlign={['left', 'right']}
          pt={1}
          fontSize={[2]}
        >
          <CollectionStats
            limit={limit}
            skip={skip}
            productsNum={products.length}
          />
        </Box>
      </Flex>
      {products.map((product, index) => {
        product.cartUrl = cartUrl;
        if (index + 1 > skip && index + 1 <= skip + limit) {
          return (
            <IndividualProduct
              key={product.shopifyId}
              product={product}
              gatsbyImageProps={gatsbyImageProps}
            />
          );
        } else {
          return '';
        }
      })}
      <Box width={1} px={4} py={2} key="pagination">
        <Text textAlign="center">
          <MainPagination {...props.pageContext} />
        </Text>
      </Box>
    </Flex>
  );
}

export default MainCatalogPage;
